"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockeryMapper = void 0;
function mockeryMapper(keyName, fakerInstance) {
    const keyToFnMap = {
        image: fakerInstance.image.url,
        imageurl: fakerInstance.image.url,
        number: fakerInstance.number.int,
        float: fakerInstance.number.float,
        hexadecimal: fakerInstance.number.hex,
        uuid: fakerInstance.string.uuid,
        boolean: fakerInstance.datatype.boolean,
        city: fakerInstance.location.city,
    };
    return keyName && keyName.toLowerCase() in keyToFnMap
        ? keyToFnMap[keyName.toLowerCase()]
        : undefined;
}
exports.mockeryMapper = mockeryMapper;
//# sourceMappingURL=zod-mockery-map.js.map